import { render, staticRenderFns } from "./Oc.vue?vue&type=template&id=3516fad9&scoped=true"
import script from "./Oc.vue?vue&type=script&lang=js"
export * from "./Oc.vue?vue&type=script&lang=js"
import style0 from "./Oc.vue?vue&type=style&index=0&id=3516fad9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3516fad9",
  null
  
)

export default component.exports